<template>
  <div class="w w1200" style="padding-top: 20px;" v-loading="loading">
    <div class="order-card" v-if="orderData[0] && orderData[0].orderType === 1">
      <el-divider content-position="left">收货地址</el-divider>
      <div class="infoBox">
        <div class="tips">大型商品下单后，收货地址将无法修改。<span class="textRedColor">快递公司会电话联系您确认送货时间，收货时需核对身份证信息。</span></div>
        <el-button type="text" icon="el-icon-plus" @click="addAddress">新增地址</el-button>
      </div>
      <div class="addressList">
        <div class="address-item" v-for="(item, index) in showAddressList" :key="item.said">
          <div class="address-user" :class="{'selected': selectedAddress && item.said === selectedAddress.said}"
               @click="selectAddress(item)">{{item.recipient}}</div>
          <div class="address-content">
            <span class="item">{{item.recipient}}</span>
            <span class="item">{{ item.areaName }}{{ item.address }}</span>
            <span class="item">{{ item.phoneNumber | phoneEncryption }}</span>
            <span v-if="item.defaultAddress === 1" class="badge">默认地址</span>
          </div>
          <div class="address-operation">
            <el-link type="warning" @click="editAddress(item)">修改</el-link>
            <el-link type="danger" @click="deleteAddress(item, index)">删除</el-link>
          </div>
        </div>
        <div class="more-trigger" v-if="addressLists.length > 1" @click="expandMore">
          更多地址
          <i :class="showMoreAddress ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </div>
      </div>
    </div>
    <div class="order-card">
      <el-divider content-position="left">发票</el-divider>
      <div class="order-card-inner">
        <el-radio-group v-model="openradio">
          <el-radio :label="1">不开发票</el-radio>
          <el-radio :label="2">开发票</el-radio>
        </el-radio-group>
      </div>
      <div class="invoiceBox" v-show="openradio===2">
        <el-form :model="billForm" label-position="left" ref="billForm" :rules="rules" label-width="80px">
          <el-form-item label="发票类型">
            <el-radio-group v-model="billForm.groupType">
              <el-radio :label="1">个人</el-radio>
              <el-radio :label="2">单位</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="抬头名称" prop="headerName">
            <el-input v-model="billForm.headerName" placeholder="请输入发票抬头"></el-input>
          </el-form-item>
          <el-form-item v-if="billForm.groupType===2" label="公司税号" prop="taxNumber">
            <el-input v-model="billForm.taxNumber" placeholder="请填写购买方纳税人识别号或统一社会信用代码"></el-input>
          </el-form-item>
          <el-form-item label="发票材质">
            <el-radio-group v-model="billForm.invoiceType">
              <el-radio :label="1">电子发票（非纸质）</el-radio>
              <el-radio :label="2">普通发票（纸质）</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div class="more">
          <dl>
            <dt>发票须知：</dt>
            <dd class="active">1.纸质发票暂不支持填写税号；付款后纳税人识别号不可修改，请确认信息后付款。</dd>
            <dd>2.电子发票可在订单完成后，在订单详情中下载和查看。</dd>
            <dd>3.发票金额为实际支付金额，不包含优惠券、礼品卡等。</dd>
            <dd class="active">
              <a @click="openCommonProblem">查看更多发票常见问题 &gt;</a>
            </dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="order-card">
      <el-divider content-position="left">订单详情</el-divider>
      <div class="order_detailInfo">
        <div class="shop-section" v-for="shop in orderData" :key='shop.bxmId'>
          <div class="shop-header">
            <span class="title">商家：{{ shop.merchantName }}</span>
          </div>
          <div v-for="good in shop.commodityList" :key='good.bxysid'>
            <el-row class="order_Info">
              <el-col :span="1">
                <el-image :src="good.specificationImg || good.commodityImage"></el-image>
              </el-col>
              <el-col :span="15" class="order_Info_item OneLineDisplay">
                <span  @click="$tools.showGoodInBlank(good.commodityId)">{{ good.commodityName }}</span>
                <span>{{ good.attributes || '默认规格' }}</span>
              </el-col>
              <el-col :span="6" class="order_Info_item">
                ￥{{ good.buyprice | decimal }} x {{ good.num }}
              </el-col>
              <el-col :span="2" class="order_Info_item">有货</el-col>
            </el-row>
            <el-row :span="24" class="order_detailInfo_price">
              <el-col :span="17">￥{{ good.buyprice * good.num }}</el-col>
            </el-row>
          </div>
          <el-row class="Fee_Dtails">
            <el-col :span="20">
              <el-popover class="red-picker" ref="popover" placement="/bottom-end" width="800" trigger="click">
                <div class="coupon-list">
                  <div class="coupon-title">选择代金券</div>
                  <template v-if="shop.userVouchers.length">
                    <div class="coupon-item cash" @click="pickCashCoupons(shop.userVouchers, item)"
                         v-for="item in shop.userVouchers" :key="item.id">
                      <div class="amount">
                        {{item.voucherPrice}}
                        <i class="el-icon-circle-check" v-show="item.checked"></i>
                      </div>
                      <div class="info">
                        <div class="type u-line">{{ item.voucherName }}</div>
                        <div class="condition">{{item.voucherParallelFlag === 'Y' ? '可叠加' : '不可叠加'}}</div>
                        <div class="condition">至{{ item.voucherEndTime | formatTime('yyyy-MM-dd HH:mm') }}有效</div>
                      </div>
                    </div>
                  </template>
                  <div class="empty" v-else>
                    <i class="el-icon-box"></i>
                    <div class="empty">暂无可用代金券</div>
                  </div>

                  <div class="coupon-title">选择红包</div>
                  <template v-if="envelopeList.length">
                    <div class="coupon-item discount" @click="getRedEnveloped(shop, item.axyRid)" v-for="item in envelopeList" :key="item.axyRid">
                      <div class="amount">
                        {{item.redenvelopesPrice | decimal}}
                        <i class="el-icon-circle-check" v-show="shop.redPayId === item.axyRid"></i>
                      </div>
                      <div class="info">
                        <div class="type"><em class="unit">¥</em>{{item.name}}</div>
                        <div class="condition">满{{item.subtotal}}元可用</div>
                      </div>
                    </div>
                  </template>
                  <div class="empty" v-else>
                    <i class="el-icon-box"></i>
                    <div class="empty">暂无可用红包</div>
                  </div>
                </div>
                <el-button slot="reference" type="default" icon="el-icon-circle-plus" size="small"
                           @click="getMerchantDiscounts(shop)">使用优惠</el-button>
              </el-popover>
              <div class="remark" style="margin-top: 10px">
                <div class="remark-label">备注:</div>
                <el-input type="textarea" v-model="shop.remark" placeholder="请输入备注"></el-input>
              </div>
            </el-col>
            <el-col :span="4" class="shop-summary">
              <el-row>
                <el-col :span="12" class="order_Info_item">商品数量：</el-col>
                <el-col :span="12" class="amount">×{{ shop.totalSkuCount || 1 }}</el-col>
              </el-row>
              <el-row>
                <el-col :span="12" class="order_Info_item">金额合计：</el-col>
                <el-col :span="12" class="amount">{{ shop.goodsAmount | decimal }}元</el-col>
              </el-row>
              <el-row>
                <el-col :span="12" class="order_Info_item">会员折扣：</el-col>
                <el-col :span="12" class="amount">-{{ shop.discountOffer | decimal }}元</el-col>
              </el-row>
              <el-row>
                <el-col :span="12" class="order_Info_item">活动优惠：</el-col>
                <el-col :span="12" class="amount">-{{ shop.promotionDiscount | decimal }}元</el-col>
              </el-row>
              <el-row>
                <el-col :span="12" class="order_Info_item">红包抵扣：</el-col>
                <el-col :span="12" class="amount">-{{ shop.redPay | decimal }}元</el-col>
              </el-row>
              <el-row>
                <el-col :span="12" class="order_Info_item">代金券抵扣：</el-col>
                <el-col :span="12" class="amount">-{{ shop.voucherPay | decimal }}元</el-col>
              </el-row>
              <el-row>
                <el-col :span="12" class="order_Info_item">运费：</el-col>
                <el-col :span="12" class="amount">{{ shop.deliveryAmount | decimal }}元</el-col>
              </el-row>
              <el-row>
                <el-col :span="12" class="order_Info_item">应付金额：</el-col>
                <el-col :span="12" class="amount">{{ shop.amount | decimal }}元</el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="order-card">
      <div class="total_price">
        <div class="price">应付总金额：<span class="amount">￥{{ totalPayAmount | decimal }}</span></div>
        <div class="address" v-if="selectedAddress">
          <span class="item">{{selectedAddress.recipient}}</span>
          <span class="item">{{ selectedAddress.areaName }}{{ selectedAddress.address }}</span>
          <span class="item">{{ selectedAddress.phoneNumber | phoneEncryption }}</span>
        </div>
      </div>
      <div class="bottom-btn">
        <el-button type="primary" class="btn-submit" @click="placeOrder">提交订单</el-button>
      </div>
    </div>

    <!-- 地址的弹框 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :destroy-on-close='true'
      :close-on-click-modal="false"
      @close='beforeClose'
      width="50%"
      title="编辑基础资料"
      class="dialogBox">
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px"
                 class="demo-ruleForm">
            <el-form-item label="收件人" prop="recipient">
                <el-input type="text" v-model="ruleForm.recipient" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phoneNumber">
                <el-input type="text" v-model="ruleForm.phoneNumber" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="地址" prop="areaid">
               <div class="addressCss" v-if="areaName">
                    <span>{{ areaName }}</span><span class="editCss" @click="isShowAddress">修改地址</span>
               </div>
              <!-- <el-input type="text" v-model="ruleForm.areaid" autocomplete="off"></el-input> -->
                <el-cascader v-else v-model="cascaderAreaValue" ref="cascaderAddr"
                  class="cascaderArea" placeholder="请选择收货地址"
                  :props="{ checkStrictly: true }" :options="getprovince" @change="areaHandleChange">
                </el-cascader>
            </el-form-item>
            <el-form-item label="详细地址" prop="address">
                <el-input v-model="ruleForm.address"></el-input>
            </el-form-item>
            <el-form-item label="邮政编码" prop="postalCode">
                <el-input v-model="ruleForm.postalCode"></el-input>
            </el-form-item>
            <el-form-item prop="">
                <el-checkbox v-model="ruleForm.defaultAddress">默认地址</el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitAddress('edit')" class="buttonBgd" v-if="showEditButtom">确定修改</el-button>
              <el-button type="primary" @click="submitAddress()" class="buttonBgd" v-else>确 定</el-button>
            </el-form-item>
            </el-form>
    </el-dialog>

    <!-- 发票须知弹框 开始 -->
    <el-dialog class="seeMoreCommonProblemBox"
      :visible.sync="seeMoreCommonProblem" width="50%" title='发票常见问题' center >
      <div class="modalContent">
          <h4>1.为什么当我选择开具单位抬头发票时，需要填写纳税⼈识别号？纳税⼈识别号哪⾥获取？</h4>
          <p>
            根据国家税务总局公告2017年第16号第⼀条规定：⾃2017年7⽉1⽇起，购买⽅为企业的，索取增值税普通发票时，应向销售⽅提供纳税⼈识别号或统⼀社会信⽤代码；销售⽅为其开具增值税普通发票时，应在“购买⽅纳税⼈识别号”栏填写购买⽅的纳税⼈识别号或统⼀社会信⽤代码。不符合规定的发票，不得作为税收凭证。纳税⼈识别号有两种⽅式获取：①联系公司财务咨询开票信息；②登录全国组织代码管理中⼼查询。<span
            class="light">（*商城⽬前使⽤的纸质发票类型属于通⽤机打发票，不在公告规定范畴内，发票规格本⾝⽆法添加税号，⽆需添加税号即可报销使⽤，所以暂不⽀持纸质发票填写单位企业税号。）</span>
          </p>
          <h4>2.非个人用户抬头的电子发票是否需要填写单位名称和纳税人识别号？</h4>
          <p>需要填写。国家税务总局要求，不符合规定的发票，不得作为税收凭证。</p>
          <h4>3.填写税号付款后是否可修改？</h4>
          <p>暂不支持修改，请认真确认后付款。</p>
          <h4>4.发票的类型有哪些？</h4>
          <p>目前可支持开具电子发票、通用机打发票。</p>
          <h4>5.发票⾦额包含优惠券、礼品卡吗？</h4>
          <p>发票⾦额为实际⽀付⾦额，不包含优惠券、礼品卡等。</p>
          <h4>6.什么是电⼦发票？</h4>
          <p>电⼦发票是指在购销商品、提供或者接受服务以及从事其他经营活动中，开具、收取的以电⼦⽅式存储的收付款凭证
            。⼩米⽹开具的电⼦发票均为真实有效的合法发票，与传统纸质发票具有同等法律效⼒，可作为⽤户维权、保修的有效凭据。</p>
          <h4>7.电⼦发票什么时候开具？</h4>
          <p>订单在⽤户确认收货，订单完成后开具电⼦发票。</p>
          <h4>8.电⼦发票在订单完成后，可在哪⾥查看？</h4>
          <p>订单完成后，你可以登录个人账户，在订单详情页中查看和下载PDF格式电子发票。</p>
          <h4>9.电⼦发票如何验证？</h4>
          <p>电⼦发票下载成功后，客户可凭借电⼦发票上所标⽰的发票代码、发票号码、防伪码在国税局授权的发票服务平台或北京市国家税局⽹站进⾏查询验证。</p>
          <h4>10.选择开具电⼦发票的顾客申请部分退货，发票如何处理？</h4>
          <p>开具电⼦发票的订单申请部分退货，原电⼦发票会通过系统⾃动冲红（原电⼦发票显⽰⽆效），并对未发⽣退货的商品重新⾃动开具电⼦发票。如整单退货，则我司将原电⼦发票做冲红处理（原电⼦发票显⽰⽆效）。</p>
          <h4>11.遇到质量问题，电⼦发票是否能作为维权的依据？</h4>
          <p>根据北京市国家税务局、北京市地⽅税务局、北京市商务委员会、北京市⼯商⾏政管理局《关于电⼦发票应⽤试点若⼲事项的公告》（2013年第8号）、《关于扩
            ⼤电⼦发票应⽤试点范围若⼲事项的公告》（2013年第18号⽂），电⼦发票与纸质发票具有相同法律效⼒，可作为售后、维权凭据。</p>
        </div>
    </el-dialog>
    <!-- 发票须知弹框 结束 -->
  </div>
</template>
<script>
import {
  immediatePlaceOrder,
  get_order,
  addresslist,
  address_add,
  address_remove,
  address_saveedit,
  addOrder,
  area_list,
  getSpecificationselect,
  getMyred,
  getStoreFreight,
  fetchOrderCashCoupons,
  fetchPlaceOrder
} from '../../api/xunyou'
import {mapState, mapMutations} from 'vuex'

export default {
  data() {
    return {
      orderData: [],
      userInfo: this.$store.state.userInfo,
      loading: false,
      showEditButtom: false,
      dialogVisible: false,
      openradio: 1,
      billForm: { // 发票里填写的内容
        invoiceType: 1,//是否是电子发票
        groupType: 1, // 个人还是单位的
        headerName: '',
        taxNumber: ''
      },
      seeMoreCommonProblem: false, // 更多常见问题弹框
      cascaderAreaValue: [],
      ruleForm: {
        muid: this.$store.state.userInfo.userId,
        recipient: '',
        phoneNumber: '',
        areaid: '',
        address: '',
        postalCode: '',
        defaultAddress: 0,
      },
      envelopeList: [], // 红包列表
      addressLists: [],
      payMethodsCheckbox: 1, // 支付方式 在线支付/货到付款
      selectedAddress: '', // 选择的收货地址id
      areaName: '',
      showMoreAddress: false,
      rules: {
        recipient: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
        phoneNumber: [
          {required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},
          {min:11, max: 11, message: "请输入正确手机号", trigger: ["blur", "change"]}
        ],
        areaid: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
        address: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
        postalCode: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
        headerName: [{
          required: true,
          trigger: ["blur"],
          validator: (rule, value, callback) => {
            if (this.openradio === 2 && !value) {
              callback(new Error('不能为空,请输入'));
            } else {
              callback();
            }
          }
        }],
        taxNumber: [{
          required: true,
          trigger: ["blur"],
          validator: (rule, value, callback) => {
            if (this.billForm.groupType === 2 && !value) {
              callback(new Error('不能为空,请输入'));
            } else {
              callback();
            }
          }

        }]
      }
    };
  },
  computed: {
    ...mapState(['getprovince']),
    showAddressList () {
      let list = this.addressLists;
      if (!this.showMoreAddress) {
        list = this.addressLists.slice(0, 1);
      }
      return list;
    },
    allCheckedCashCouponCodes() {
      const codes = [];
      this.orderData.forEach(shop => {
        if (shop.userVouchers.length) {
          shop.userVouchers.forEach(coupon => {
            if (coupon.checked) codes.push(coupon.userVoucherCode);
          });
        }
      });
      return codes;
    },
    orderGoodsList () {
      return this.$store.state.selectedGoodsFromCart;
    },
    cartGoodIds () {
      const ids = [];
      this.orderGoodsList.forEach(mer => {
        mer.goods.forEach(good => {
          ids.push(good.scid);
        })
      })
      return ids;
    },
    totalPayAmount () {
      return this.orderData.reduce((res, cur) => {
        return res += cur.amount;
      }, 0);
    }
  },
  mounted() {
    this.initData();
  },
  methods: {
    // 初始化数据
    async initData () {
      await this.getAddressList();
      this.placeOrderPreview();
    },
    // 地址查询
    getAddressList() {
      return new Promise(resolve => {
        addresslist({muid: this.userInfo.userId}).then(res => {
          if (res.code === 0) {
            this.addressLists = res.rows;
            const defaultAddress = res.rows.find(ele => ele.defaultAddress === 1);
            if (defaultAddress) {
              this.selectedAddress = defaultAddress;
            } else {
              this.selectedAddress = res.rows[0];
            }
          }
          resolve();
        }).catch(err => {
          resolve();
          this.$message.error('查询收货失败，请稍后再试！')
        })
      });
    },
    // 下单预览
    placeOrderPreview () {
      const orders = this.orderGoodsList.map(mer => {
        const goodsList = mer.goods.map(good => ({ bxysid: good.skuId, num: good.number }));
        return {
          bxmId: mer.bxmId,
          commodityList: goodsList
        }
      });
      const params = {
        muid: this.$store.getters.userId,
        doCommit: false, // false表示预览
        addressId: this.selectedAddress ? this.selectedAddress.said : '',
        orders: orders
      };
      this.loading = true;
      fetchPlaceOrder(params).then(res => {
        console.log('下单结果：', res);
        this.loading = false;
        if (res.code === 0) {
          res.data.forEach(ele => {
            if (!ele.userVouchers) {
              ele['userVouchers'] = [];
            }
          });
          this.orderData = res.data;
        }
      }).catch(err => {
        this.loading = false;
        this.$message.error('下单失败，请稍候重试!');
      });
    },
    // 处理下单数据
    handleOrderData () {
      const res = [];
      this.orderData.forEach(mer => {
        const userVouchers = mer.userVouchers.reduce((res, cur) => {
          if (cur.checked) res.push(cur.userVoucherCode);
          return res;
        }, [])
        const goodsList = mer.commodityList.map(good => ({ bxysid: good.bxysid, num: good.num }));
        const titleArr = mer.commodityList.map(good => (`${good.commodityName}×${good.num}`));
        res.push({
          bxmId: mer.bxmId,
          title: titleArr.join(';'),
          userVouchers: userVouchers,
          redPayId: mer.redPayId || '',
          remark: mer.remark,
          commodityList: goodsList
        });
      });
      return res;
    },
    // 更新订单信息
    updateOrder () {
      const params = {
        muid: this.$store.getters.userId,
        addressId: this.selectedAddress ? this.selectedAddress.said : '',
        doCommit: false, // false表示预览
        orders: this.handleOrderData()
      };
      fetchPlaceOrder(params).then(res => {
        console.log('更新下单结果：', res);
        if (res.code === 0) {
          res.data.forEach((order, index) => {
            this.orderData[index].totalSkuCount = order.totalSkuCount;
            this.orderData[index].goodsAmount = order.goodsAmount;
            this.orderData[index].discountOffer = order.discountOffer;
            this.orderData[index].promotionDiscount = order.promotionDiscount;
            this.orderData[index].redPay = order.redPay;
            this.orderData[index].voucherPay = order.voucherPay;
            this.orderData[index].deliveryAmount = order.deliveryAmount;
            this.orderData[index].amount = order.amount;
          });
        }
      }).catch(err => {
        this.$message.error('下单失败，请稍候重试!');
      });
    },
    // 订单下单
    placeOrder () {
      if (this.orderData[0].orderType === 1 && !this.selectedAddress) {
        this.$message.warning('请先选择收货地址');
        return false;
      }
      this.$refs.billForm.validate(valid => {
        if (valid) {
          const params = {
            muid: this.$store.getters.userId,
            addressId: this.selectedAddress ? this.selectedAddress.said : '',
            cartIds: this.cartGoodIds.length ? this.cartGoodIds : '',
            doCommit: true, // false表示预览
            orders: this.handleOrderData()
          };
          if (this.openradio === 2) {
            params['orderInvoice'] = {
              type: this.billForm.invoiceType,	//发票类型 是否是电子发票
              attribution: this.billForm.groupType,	//发票形势 个人还是单位的
              invoiceTitle: this.billForm.headerName, //发票抬头
              code: this.billForm.taxNumber,	//信用代码
            }
          }
          this.loading = true;
          fetchPlaceOrder(params).then(res => {
            console.log('确定下单结果：', res);
            this.loading = false;
            if (res.code === 0) {
              const orderNos = res.data.map(order => order.orderNumber);
              this.$store.commit('SAVE_PAY_ORDER', orderNos);
              this.$router.replace('/orderNow');
            } else {
              this.$message.error(res.msg);
            }
          }).catch(err => {
            this.loading = false;
            this.$message.error('下单失败，请稍候重试!');
          });
        }
      });
    },
    // 选择代金券，可以选择多张
    pickCashCoupons(voucherList, coupon) {
      if (!coupon.checked) {
        if (coupon.voucherParallelFlag === 'Y') {
          const arr = voucherList.filter(ele => (ele.checked && ele.voucherParallelFlag === 'N'))
          if (arr.length) {
            this.$message.warning('已选中不可叠加使用券，当前券不可使用');
            return ;
          }
        } else {
          const arr = voucherList.filter(ele => ele.checked);
          if (arr.length) {
            this.$message.warning('当前券不可与其它券叠加使用');
            return ;
          }
        }
      }
      // 此券已经在别的订单中被选中
      if (this.allCheckedCashCouponCodes.indexOf(coupon.userVoucherCode) > -1) {
        if (coupon.checked) {
          // 此时券被选中，取消选择
          coupon.checked = false;
        } else {
          // 此时券未被选中，不允许选择
          this.$message.warning('此代金券已在其它店铺中被使用！');
        }
      } else {
        coupon.checked = true;
      }
      this.updateOrder();
    },
    //   红包选择
    getRedEnveloped(shop, axyRid) {
      shop.redPayId = axyRid;
      this.updateOrder();
    },
    // 查询优惠信息
    getMerchantDiscounts (merchant) {
      this.myReceivedPack(merchant);
      this.getCashCoupons(merchant);
    },

    // 查询我领过的相关商品的红包
    myReceivedPack(merchant) {
      getMyred({
        muid: this.$store.getters.userId,
        status: 1,
        mid: merchant.bxmId, // 店铺id
        subtotal: merchant.goodsAmount // 店铺里商品总价
      }).then(res => {
        console.log('店铺可用红包列表', res);
        if (res.code === 0) {
          this.envelopeList = res.rows;
        }
      }).catch(err => {
        this.$message.error('查询收货失败，请稍后再试！')
      })
    },
    // 查询代金券
    getCashCoupons(merchant) {
      if (merchant.userVouchers.length) return ; // 已经存在，不用再次获取
      const ids = merchant.commodityList.map(good => good.bxysid);
      let areaId = '';
      let province = '';
      let city = '';
      if (this.selectedAddress) {
        areaId = this.selectedAddress.areaid;
        province = areaId.substr(0, 2);
        city = areaId.substr(0, 4);
      }
      const params = {
        muid: this.$store.getters.userId,
        province: province ? `${province}0000` : '',
        city: city ? `${city}00` : '',
        area: areaId,
        specificationIds: ids
      };
      fetchOrderCashCoupons(params).then(res => {
        console.log('订单可用代金券列表：', res);
        if (res.code === 0) {
          merchant.userVouchers = res.data.map(ele => {
            ele['checked'] = false;
            return ele;
          });
        }
      });
    },
    isShowAddress() {
      this.areaName = ''
    },
    // 选择收货地址,更新运费信息;
    // 清空代金券信息
    // 更新订单信息
    selectAddress(address) {
      this.orderData.forEach(shop => {
        shop.userVouchers = [];
      });
      this.selectedAddress = address;
      this.placeOrderPreview();
    },
    // 填写地址选择
    areaHandleChange(value) {
      this.$refs['cascaderAddr'].getCheckedNodes()
      this.ruleForm.areaid = value[value.length - 1]
    },
    // 添加地址
    addAddress() {
      this.dialogVisible = true
    },
    //   关闭弹框清空
    beforeClose() {
      this.ruleForm = {}
      this.showEditButtom = false
    },
    //   新增收货地址
    submitAddress(item) {
      //   console.log(editReq,'xiugai1')
      if (item == 'edit') {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            let editReq = {
              muid: this.ruleForm.muid,
              said: this.ruleForm.said,
              recipient: this.ruleForm.recipient,
              phoneNumber: this.ruleForm.phoneNumber,
              areaid: this.ruleForm.areaid,
              address: this.ruleForm.address,
              postalCode: this.ruleForm.postalCode,
              defaultAddress: this.ruleForm.defaultAddress ? 1 : 0
            }
            address_saveedit(editReq).then(res => {
                if (res.code == 0) {
                  this.showEditButtom = false
                  this.dialogVisible = false
                  this.ruleForm = {}
                  this.cascaderAreaValue = []
                  this.getAddressList()
                } else {
                  this.$message.error(res.msg);
                }
              }).catch(err => {
                this.dialogVisible = false
                this.$message.error('修改失败，请稍后再试！')
              })
          }
        });
      } else {
        this.$refs.ruleForm.validate((valid) => {
          this.ruleForm.muid = this.userInfo.userId;
          this.ruleForm.defaultAddress = this.ruleForm.defaultAddress ? 1 : 0;
          if (valid) {
            address_add(this.ruleForm).then(res => {
                if (res.code == 0) {
                  this.dialogVisible = false
                  this.ruleForm = {}
                  this.getAddressList()
                } else {
                  this.$message.error(res.msg);
                }
              }).catch(err => {
                this.dialogVisible = false
                this.$message.error('提交失败，请稍后再试！')
              })
          }
        });
      }
    },

    //   删除地址
    deleteAddress(address, index) {
      this.$confirm('确定删除地址?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        address_remove({ids: address.said}) .then(res => {
            if (res.code === 0) {
              this.addressLists.splice(index, 1);
              if (this.selectedAddress && this.selectedAddress.said === address.said) {
                this.selectedAddress = null;
              }
            }
          }) .catch(err => {
            this.$message.error('删除失败，请稍后再试！')
          })
      });
    },
    // 修改地址
    editAddress(item) {
      console.log(item, '选择的每一项地址')
      this.areaName = item.areaName
      this.dialogVisible = true
      this.showEditButtom = true
      this.ruleForm = {
        muid: item.muid,
        said: item.said,
        recipient: item.recipient,
        phoneNumber: item.phoneNumber,
        areaid: item.areaid,
        address: item.address,
        postalCode: item.postalCode,
        defaultAddress: item.defaultAddress == 1,
      }
    },
    expandMore () {
      this.showMoreAddress = !this.showMoreAddress;
    },
    openCommonProblem() {
      this.seeMoreCommonProblem = true
    }
  }
};
</script>

<style scoped lang="less">
.el-radio.is-bordered.is-checked{
  border-color: var(--main-theme-color);
}
/deep/ .el-radio__input.is-checked{
  .el-radio__inner{
    border-color: var(--main-theme-color);
    background: var(--main-theme-color);
  }
  &+.el-radio__label{
    color: var(--main-theme-color);
  }
}
.addressList {
  color: #666666;
  .more-trigger{
    font-size: 12px;
    cursor: pointer;
    &:hover,&:focus{
      color: #333333;
    }
  }
  .address-item{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 10px 0;
    .address-user{
      width: 120px;
      height: 30px;
      border: 1px solid #cccccc;
      text-align: center;
      line-height: 30px;
      border-radius: 3px;
      cursor: pointer;
      &.selected,
      &:hover,&:focus{
        border-color: var(--main-theme-color);
      }
    }
    .address-content{
      flex: 1;
      margin: 0 5px;
      padding: 3px 0;
      &:hover,&:focus{
        background-color: rgba(225, 225, 225, 0.3);
      }
      .item{
        margin: 0 5px;
      }
      .badge{
        background-color: #cccccc;
        color: #fff;
        font-size: 12px;
        border-radius: 2px;
        text-align: center;
        padding: 3px 5px;
      }
    }
  }

}
.bottom-btn{
  text-align: right;
  margin-top: 10px;
  .btn-submit{
    background-color: var(--main-theme-color);
    border-color: var(--main-theme-color);
  }
}
.total_price {
  text-align: right;
  color: #777777;
  .amount {
    font-size: 24px;
    color: var(--main-theme-color);
    font-weight: bold;
  }
}

.order-card {
  padding: 10px 30px;
  background: white;

  .infoBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    .textRedColor {
      color: var(--main-theme-color);
    }
  }
}
.invoiceBox{
  width: 450px;
  background-color: #f5f5f5;
  padding: 15px;
  margin: 15px 0 0 0;
  border-radius: 5px;
  /deep/ .el-form-item{
    margin-bottom: 15px;
  }
}
.order_Info {
  font-size: 0;
  .el-image {
    height: 30px;
    width: 30px;
  }
  .order_Info_item {
    line-height: 30px;
    font-size: 14px;
  }
  span.addIcon {
    background: var(--main-theme-color);
    color: white;
    font-size: 12px;
    margin-left: 10px;
    padding: 2px 5px;
    box-sizing: border-box;
    border-radius: 4px;
  }
}

.order_detailInfo {
  font-size: 14px;
  .shop-section{
    background-color: #F5F5F5;
    padding: 0 15px;
    margin-bottom: 10px;
    border-radius: 5px;
    &:last-child{
      margin-bottom: 0;
    }
    .shop-header{
      padding: 10px 0;
      font-weight: 500;
    }
  }
  .shop-summary{
    text-align: right;
    font-size: 12px;
    line-height: 24px;
    color: #777777;
    .amount{
      color: var(--main-theme-color);
    }
  }
  .nodate {
    text-align: center;
    margin: 70px;
    font-size: 16px;
  }

  .order_detailInfo_price {
    padding: 0 45px;
    color: var(--main-theme-color);

    span.addIcon {
      background: var(--main-theme-color);
      color: white;
      font-size: 12px;
      margin-left: 10px;
      padding: 2px 8px;
      box-sizing: border-box;
      border-radius: 4px;
    }
  }
}

.Fee_Dtails {
  padding: 10px 0;
  font-size: 14px;
  border-top: 1px dashed #DCDFE6;
  .red-picker{
    .title{
      font-weight: 500;
    }
    .empty{
      text-align: center;
      height: 80px;
      color: #cccccc;
      .el-icon-box{
        margin-top: 15px;
        font-size: 30px;
      }
    }
  }
  .coupon-list{
    padding: 10px 0;
    .coupon-title{
      font-weight: 500;
      margin-bottom: 10px;
    }
    .coupon-item{
      width: 230px;
      padding: 10px 0;
      display: inline-flex;
      justify-content: flex-start;
      align-items: stretch;
      color: #fff;
      border-radius: 5px;
      margin-bottom: 10px;
      margin-right: 10px;
      cursor: pointer;
      &:hover, &:focus{
        box-shadow: 0px 0px 6px rgba(93,93,93,0.3);
      }
      &.discount{
        background: linear-gradient(42deg, #ff9800, #ff8d35);
      }
      &.cash{
        background: linear-gradient(43deg, #ff5656, #ffa183);
      }
      &.disabled{
        filter: grayscale(1);
        cursor: no-drop;
      }
      .amount{
        position: relative;
        width: 70px;
        font-size: 18px;
        line-height: 45px;
        font-weight: bold;
        text-align: center;
        border-right: 1px dashed rgba(255,255,255,0.7);
        &:before{
          content: '￥';
          font-size: 12px;
        }
        .el-icon-circle-check{
          position: absolute;
          top: -8px;
          left: 3px;
          color: #fff;
          font-weight: bold;
        }
      }
      .info{
        flex: 1;
        font-size: 12px;
        padding-left: 10px;
        .type{
          font-size: 14px;
          font-weight: bold;
          margin-bottom: 5px;
        }
      }
    }
  }
}
.mt-20{
  margin-top: 20px;
}





.orderBox {
  padding: 20px;
  background: white;
  margin-top: 20px;

}

.cascaderArea.el-cascader {
  width: 100%;

  /deep/ input[disabled], /deep/ input[disabled="disabled"], /deep/ input[readonly], /deep/ input[readonly="readonly"] {
    background-color: white;
  }
}

.seeMoreCommonProblemBox {

  /deep/ .el-dialog__body {
    text-align: center !important;

    .modalContent {
      text-align: left;
      padding-bottom: 20px;
    }
  }
}

.addressCss {
  display: flex;
  justify-content: space-between;

  .editCss {
    color: var(--main-theme-color);
    cursor: pointer;
  }
}

</style>







// WEBPACK FOOTER //
// src/views/shoppingcart/orderDetail.vue